import PropTypes from 'prop-types';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack, Paper, Skeleton } from '@mui/material';
// mock
// import account from '../../../_mock/account';
// hooks
import { useCollection } from 'react-firebase-hooks/firestore';
import { DateTime } from 'luxon';
import TempInfo from '../../../models/tempinfo';
import CheckinsService from '../../../services/checkins.service';
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';
import { AppContext, rankNameUnitaliasFrom, validatedDateTime } from '../../../App';
import { ROLES, getTempColors } from '../../../constants';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const [currentTempInfo, loadingCurrentTempInfo, errorLoadingCurrentTempInfo] = useCollection(CheckinsService.tempInfo)
  const [allStaffs, setAllStaffs] = useState([]);
  const [trainerojt, loadingTrainerojt, errorLoadingTrainerojt ] = useCollection(CheckinsService.getUserBeaconByRole('trainerojt'))
  const [staffs, loadingStaffs, errorLoadingStaffs ] = useCollection(CheckinsService.getUserBeaconByRole('staff'))
  const [admin, loadingAdmin, errorLoadingAdmin ] = useCollection(CheckinsService.getUserBeaconByRole('admin'))
  const [superadmin, loadingSuperadmin, errorLoadingSuperadmin ] = useCollection(CheckinsService.getUserBeaconByRole('superadmin'))

  const { user } = useContext(AppContext);
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const tempInfo = useMemo(() => {
    if (loadingCurrentTempInfo || !currentTempInfo || currentTempInfo.empty) return {}
    console.log('currentTempInfo', currentTempInfo.docs.length);
    const info = currentTempInfo.docs[0]
    console.log('info.data()', info.data());
    return info.data()

  }, [currentTempInfo, loadingCurrentTempInfo])

  const temperatureInfo = useMemo(() => {
    if (!tempInfo) return {}
    return new TempInfo(tempInfo)
  }, [tempInfo])

  useEffect(() => {

    if (loadingCurrentTempInfo) return
    if (currentTempInfo && !currentTempInfo.empty && currentTempInfo.docChanges && currentTempInfo.docChanges.length) {
      console.log('currentTempInfo.docChanges', currentTempInfo.docChanges);
    }
  }, [currentTempInfo, loadingCurrentTempInfo]);

  useEffect(() => {

    setAllStaffs( [superadmin, admin, staffs, trainerojt].reduce((p, typedStaffs) => {
      if (typedStaffs && !typedStaffs.empty) {
        const users = typedStaffs.docs
          .filter(d =>
            // console.log('lastseen) > utc().minus minute: 60', validatedDateTime(s.lastseen).valueOf(), DateTime.utc().minus({ minute: 60 }).valueOf());
            d.data().lastseen && validatedDateTime(d.data().lastseen) > DateTime.utc().minus({ minute: 30 }) && (user.role === 'superadmin' || (d.data().checkedIn && validatedDateTime(d.data().checkedIn) > DateTime.utc().minus({ hours: 3 })))
          )
        .map(d => d.data()
        // Object.values(d.data()) && Object.values(d.data())[0].displayName ? Object.values(d.data())[0] : d.data()
        )
        console.log(users.length);
        if (p.length) { p.push(...users) } else { p = users }
      }
      return p;
    }, []))
}, [admin, staffs, superadmin, trainerojt]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      {/* <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={account.pictureUrl} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {account.displayName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role && (ROLES[account.role].name || account.role.toUpperCase())}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box> */}

      <NavSection data={navConfig} />
      <Box sx={{ flexGrow: 1 }} />
      {loadingCurrentTempInfo && temperatureInfo && temperatureInfo.getUnifiedTemperature() > 0 ? <Skeleton variant="rectangular" width={210} height={60} /> : temperatureInfo && !Number.isNaN(temperatureInfo.temperator) ? <Box sx={{ mb: 2, mx: 1.5 }}>
        <Stack direction={'column'} spacing={1} >
          <Stack direction={'row'} spacing={1}>
            <Paper elevation={2} sx={{ width: '50%', p: 1, bgcolor: getTempColors(temperatureInfo.getUnifiedTemperature()) }} style={{ textAlign: 'center' }}>
            <Typography variant="caption" gutterBottom>
              อุณหภูมิห้อง
            </Typography>
            <Typography variant="h4" gutterBottom>
              {temperatureInfo.getTemperature()}
            </Typography>
          </Paper>
            <Paper elevation={2} sx={{ width: '50%', p: 1 }} style={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="caption">
              ความชื้น
            </Typography>
            <Typography gutterBottom variant="h5">
              {temperatureInfo.getHumidity()}
            </Typography>
          </Paper>
          </Stack>

          {allStaffs.length ?
            <>
              <Paper elevation={1} style={{ textAlign: 'center' }}>
                <Typography gutterBottom variant="h5">
                  {'RUNWAYWATCH'}
                </Typography>
              </Paper>
              {allStaffs
              // .filter(s =>
              //   // console.log('lastseen) > utc().minus minute: 60', validatedDateTime(s.lastseen).valueOf(), DateTime.utc().minus({ minute: 60 }).valueOf());
              //    validatedDateTime(s.lastseen) > DateTime.utc().minus({ minute: 30 })
              // )
              .map(account => {
                const rankNameUnitalias = rankNameUnitaliasFrom(account);
                return (
                <Box key={account.displayName} sx={{ mb: 1, mx: 2.5 }}>
                  <Link underline="none">
                    <StyledAccount>
                      <Avatar src={account.pictureUrl} alt="photoURL" />

                      <Box sx={{ ml: 2 }}>
                        <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                          {rankNameUnitalias || account.displayName}
                        </Typography>

                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                          {account.role && (ROLES[account.role].name || account.role.toUpperCase())}
                        </Typography>
                      </Box>
                    </StyledAccount>
                  </Link>
                </Box>)
              }
                )}</>
            : <></>}

        </Stack>
      </Box> : <></>}
      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>
          <Box
            component="img"
            src="/assets/images/runway/runway_banner2.png"
            // sx={{ width: 160 }}
          />

          {/* <Box sx={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="h6">
              Get more?
            </Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              From only $69
            </Typography>
          </Box>

          <Button href="https://material-ui.com/store/items/minimal-dashboard/" target="_blank" variant="contained">
            Upgrade to Pro
          </Button> */}
        </Stack>
      </Box>
    </Scrollbar>
  );

  if (pathname.includes("userprofile")) return <></>

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
